import { render } from "./homeWork.vue?vue&type=template&id=0ed9d82c&scoped=true"
import script from "./homeWork.vue?vue&type=script&lang=js"
export * from "./homeWork.vue?vue&type=script&lang=js"

import "./homeWork.vue?vue&type=style&index=0&id=0ed9d82c&scoped=true&lang=less"

import exportComponent from "F:\\project\\trade_lab_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed9d82c"]])

export default __exports__